
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import ResponsiveImage from '~/components/ResponsiveImage/ResponsiveImage.vue'

@Component({
  components: {
    ResponsiveImage,
  },
})
export default class ComparatorFeaturesBanner extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  readonly title!: string

  @Prop({
    required: false,
    type: String,
    default: '',
  })
  subtitle!: string

  get bannerUrl () {
    const folderPath = '/assets/comparator-banners/'
    const imageName = `header-${this.$i18n?.locale || 'en'}.png`

    if (typeof window !== 'undefined') {
      return `url(//${window?.location?.host || ''}${folderPath}${imageName})`
    }

    return ''
  }
}
